import { render, staticRenderFns } from "./examHouseDashboard.vue?vue&type=template&id=044fd408&scoped=true"
import script from "./examHouseDashboard.vue?vue&type=script&lang=js"
export * from "./examHouseDashboard.vue?vue&type=script&lang=js"
import style0 from "./examHouseDashboard.vue?vue&type=style&index=0&id=044fd408&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044fd408",
  null
  
)

export default component.exports